import AbstractFileInput from './AbstractFileInput';

export default class File extends AbstractFileInput {
    constructor() {
        super();
    }
}
